import React, { useState, useEffect } from 'react';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Layout/Sidebar';
import ClientInfo from '../components/Dashboard/ClientInfo';
import InitialDashboard from '../components/Dashboard/InitialDashboard';
import CreatingAccountPage from '../components/Dashboard/CreatingAccountPage';
import api from '../services/api';
const Dashboard = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    loadProfile();
  }, []);
  const loadProfile = async () => {
    try {
      const response = await api.get('/client/profile');
      setProfile(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to load profile:', error);
      if (error.response?.status === 401) {
        navigate('/login');
      } else {
        setError('Failed to load profile');
        setLoading(false);
      }
    }
  };
  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" />
        <p className="mt-3">Loading...</p>
      </Container>
    );
  }
  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }
  const renderDashboard = () => {
    if (!profile) return null;
    if (profile.source === 'clientsip_add') {
      if (profile.status_id === 0 || profile.status_id === 1) {
        return <InitialDashboard profile={profile} onUpdate={loadProfile} />;
      }
      if (profile.status_id === 2) {
        return <CreatingAccountPage />;
      }
    }
    return (
      <div className="d-flex">
        <Sidebar />
        <div className="flex-grow-1">
          <ClientInfo />
        </div>
      </div>
    );
  };
  return renderDashboard();
};
export default Dashboard;